import { render, staticRenderFns } from "./ChooseLocation.vue?vue&type=template&id=223445b3&"
import script from "./ChooseLocation.vue?vue&type=script&lang=js&"
export * from "./ChooseLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports